<template>
    <div class='body-main'>
        <div class="order-main clearfix">
            <div class="slider">
                <h1>订单中心</h1>
            </div>
            <el-tabs v-model="activesty" :tab-position="'left'" style="min-height: 470px;margin-top: 30px;">
                <el-tab-pane label="我的订单" name="dd">
                    <el-tabs type="border-card" v-if="activesty == 'dd'" style="min-height: 500px;">
                        <el-tab-pane label="全部">
                            <Orderlist v-bind:operation="'all'"/>
                        </el-tab-pane>
                        <el-tab-pane label="未支付">
                            <Orderlist v-bind:operation="'none'"/>
                        </el-tab-pane>
                        <el-tab-pane label="已完成">
                            <Orderlist v-bind:operation="'ok'"/>
                        </el-tab-pane>
                    </el-tabs>
                </el-tab-pane>
                <el-tab-pane label="发票索取" name="sq">
                    <askforinvoice v-if="activesty == 'sq'" v-on:showlb="showlb"/>
                </el-tab-pane>
                <el-tab-pane  label="发票列表" name="lb">
                    <check-the-invoice v-if="activesty == 'lb'"/>
                </el-tab-pane>
                <el-tab-pane  label="发票信息管理" name="xx">
                    <invoicemanagement v-if="activesty == 'xx'"/>
                </el-tab-pane>
                <el-tab-pane label="发票寄送地址管理" name="dz">
                    <site/>
                </el-tab-pane>
            </el-tabs>
        </div>

        <!--登入-->
        <login v-bind:loginShow="loginShow" v-bind:activeName="activeName" @close="closeloginModal"/>
    </div>
</template>

<script>
    import Orderlist from './orderlist'
    import Login from "./login";
    import Site from "./site";
    import Askforinvoice from "./askforinvoice";
    import Invoicemanagement from "./invoicemanagement";
    import CheckTheInvoice from "./checkTheInvoice";

    export default {
        name: "ordercenter",
        components: {
            CheckTheInvoice,
            Invoicemanagement,
            Askforinvoice,
            Login,
            Orderlist,
            Site
        },
        data() {
            return {
                activeName: "login",
                loginShow: false,
                activesty: "dd",
            }
        },
        methods: {
            //关闭登入modal
            closeloginModal() {
                this.loginShow = false;
            },
            showlb() {
                this.activesty = 'lb';
            },
        },

    }
</script>

<style>
    .body-main {
        min-height: 720px !important;
    }

    .order-main {
        width: 1152px;
        margin: 36px auto;
    }

    .slider h1 {
        padding-bottom: 16px;
        font-size: 18px;
        color: #4d555d;
        line-height: 32px;
        border-bottom: 1px solid #d9dde1;
    }

    .el-tabs__item {
        width: auto !important;
    }
</style>